import classNames from 'classnames';
import React, { FC, useContext } from 'react';
import { Accordion } from '../Accordion';
import { Box } from '../Box';
import { Divider } from '../Divider';
import styles from './SelectableToggleBox.module.scss';
import { SelectableToggleBoxContext } from './SelectableToggleBoxContext';

export const SelectableToggleBoxBody: FC = ({ children }) => {
	const { size } = useContext(SelectableToggleBoxContext);

	return (
		<Accordion.Body as={Box} className={classNames(styles.selectableToggleBoxBody, 'mb-last-0 position-relative')}>
			<Divider
				className={classNames('my-4', {
					['my-xl-7']: size === 'md',
				})}
			/>

			{children}
		</Accordion.Body>
	);
};
